import React, { useEffect, useState } from "react";
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getStaticFloorPlan, getStaticMonitorType, getStaticReportMonitorStatus } from "../../slices/staticData/thunk";
import DeviceTable from "./DeviceTable";

export const DEVELOPER_TAB_OVERVIEW = "1";

function Developer() {
  const { t } = useTranslation();
  const [developerTab, setDeveloperTab] = useState(DEVELOPER_TAB_OVERVIEW);
  const selectedReportID = useSelector(state => state.Event.report.reportID);
  const isModifiedReportID = useSelector(state => state.Event.report.isModifiedReportID);
  const toggleCustom = (tab) => {
    if (developerTab !== tab) {
      setDeveloperTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="p-0">
          <Nav tabs className="nav nav-tabs nav-tabs-custom nav-primary">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: developerTab === DEVELOPER_TAB_OVERVIEW,
                })}
                onClick={() => {
                  toggleCustom(DEVELOPER_TAB_OVERVIEW);
                }}
              >
                {(selectedReportID !== undefined && selectedReportID!== null && isModifiedReportID? "* ":"") + t('PageReport.Tab.Overview') + (selectedReportID!== undefined && selectedReportID!== null?" [" + selectedReportID.name+"]":"")}
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent
            activeTab={developerTab}
            className="text-muted report-tab-container"
          >
            <TabPane tabId={DEVELOPER_TAB_OVERVIEW}>
              <div className="d-flex flex-column">
               <DeviceTable toggleTag={(tagID)=>{toggleCustom(tagID)}}/>
              </div>
            </TabPane>
          </TabContent>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default Developer;
